import { render, staticRenderFns } from "./ModalCampaignDelete.vue?vue&type=template&id=e80d937c"
import script from "./ModalCampaignDelete.vue?vue&type=script&lang=js"
export * from "./ModalCampaignDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports